<template>
  <div ref="context">
    <slot/>
  </div>
</template>

<script setup>
import { onMounted, ref } from "vue"

const props = defineProps({
  selector: { type: String, default: ".active" },
})

const context = ref()

onMounted(() => {
  const matches = context.value.querySelectorAll(props.selector)

  if (!matches.length) {
    return
  }

  // scroll into view anything that matches the selector
  for (const match of matches) {
    match.scrollIntoView({ block: "center" })
  }

  // scroll into view focuses the element so reset focus back to body
  document.body.tabIndex = 0
  document.body.focus()
  document.body.blur()
  document.body.tabIndex = -1
})
</script>
